import { AdobeBaseEvent } from './adobe-base-event';
import { AnalyticsEventType } from '../models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { RewardsEvent } from '@/services/analytics/events/rewards-event';

export class AdobeRewardsEvent extends AdobeBaseEvent {
    name = 'AdobeRewardsEvent';
    event = AnalyticsEventType.Reward;

    constructor(
        event: RewardsEvent,
        store: Store<AppState>,
        services: ServicesContainer,

    ) {
        super(store, services);

        this.web.webPageDetails.name = event.pageName;
        this.account.rewardTitle = event.rewardTitle;
        this.account.rewardsID = event.rewardsID;
        this.account.rewardsPath = event.rewardsPath;
        this.account.rewardsType = event.rewardsType;

        switch(event.eventType) {
            case 'rewardsAddedToWallet':
                this.account.rewardsAddedToWallet = { value: 1 };
                break;              
            case 'rewardsAddedToBag':
                this.account.rewardsAddedToBag = { value: 1 };
                this.web.webInteraction = {
                    linkClicks: { value: 1 },
                    linkName: event.linkName,
                    linkSection: event.linkSection || (store.state.adobe.isCyobModalFromAutoPopup ? "(popup-modal)" : "rewards-home-logged-in-cards"),
                    linkTitle: event.linkTitle,
                    name: event.linkName,
                    type: 'other'
                };
                break;
            case 'error':
                const error = event.error?.response.data;
                const correlationID = error?.correlationId;
                const errorCode = error?.errorCode;
                this.event = AnalyticsEventType.Error;
                this.error = {
                    errorMessage: error?.message ?? '',
                    errorName: `rewards|${error?.message ?? ''}`,
                    errors: { value:1 }, 
                    errorType: "rewards"
                }

                if (correlationID) {
                    this.error.correlationID = correlationID;
                }

                if (errorCode) {
                    this.error.errorCode = errorCode;
                }
                break;
        }
    }
}